import { Inject, Injectable, NgZone, Optional } from '@angular/core';

import { FluidHostContext } from '../../fluid-content/scopes/fluid-host-context';
import { FluidInstrumentationService } from '../../fluid-content/utils/fluid-instrumentation-service';
import { EncryptionConfigService } from '../../service-worker/encryption/encryption-config.service';
import { ServiceWorkerStateService } from '../../service-worker/service-worker-state.service';
import { UploadLocalFileService } from '../../upload/upload-local-file/upload-local-file.service';
import { WorkloadQueryParameter } from '../constants/workload-query-parameter.enum';
import { WorkloadQueryParameterToken } from '../constants/workload-query-parameter.injection-token';
import { AriaEventFactoryService } from '../instrumentation/aria.service';
import { InstrumentationService } from '../instrumentation/instrumentation.service';
import { UserProfileService } from '../instrumentation/user-profile.service';
import { WrapperVersion } from '../models/wrapper-version.model';
import { AadAppId, AAD_APP_ID } from '../services/aad-app-id.injection-token';
import { AccessTokenService } from '../services/access-token.service';
import { DataSecurityService } from '../services/data-security.service';
import { DeviceDetector } from '../services/device-detector.service';
import { ErrorDialogService } from '../services/error-dialog.service';
import { FloodgateService } from '../services/floodgate.service';
import { OfficeRouteService } from '../services/office-route.service';
import { OfficeHomeApiConfigService } from '../services/officehome-api-config.service';
import { PerformanceService } from '../services/performance.service';
import { SchedulerService } from '../services/scheduler.service';
import { WacContentService } from '../services/wac-content.service';
import { WRAPPER_VERSION } from '../services/wrapper-version.token';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { ContextService } from '../shared-context/context.service';
import { ReactShellConfigService } from '../shared-context/react-shell-config.service';
import { UserContextService } from '../shared-context/user-context.service';
import { bootstrapOfficeStart } from './bootstrap-office-start';

@Injectable({
    providedIn: 'root'
})
export class OfficeStartBootstrapperService {
    constructor(
        private readonly clientStartupConfigService: ClientStartupConfigService,
        @Inject(AAD_APP_ID) private readonly aadAppId: AadAppId,
        private readonly accessTokenService: AccessTokenService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly contextService: ContextService,
        private readonly errorDialogService: ErrorDialogService,
        private readonly fluidHostContext: FluidHostContext,
        private readonly fluidInstrumentationService: FluidInstrumentationService,
        private readonly instrumentationService: InstrumentationService,
        private readonly officeHomeApiConfigService: OfficeHomeApiConfigService,
        private readonly officeRouteService: OfficeRouteService,
        private readonly performanceService: PerformanceService,
        private readonly ariaEventFactoryService: AriaEventFactoryService,
        private readonly scheduler: SchedulerService,
        private readonly serviceWorkerStateService: ServiceWorkerStateService,
        private readonly dataSecurityService: DataSecurityService,
        private readonly deviceDetector: DeviceDetector,
        private readonly ngZone: NgZone,
        private readonly wacContentService: WacContentService,
        @Inject(WorkloadQueryParameterToken) private readonly workloadQueryParam: WorkloadQueryParameter,
        private readonly uploadLocalFileService: UploadLocalFileService,
        private readonly userContextService: UserContextService,
        private readonly userProfileService: UserProfileService,
        private readonly reactShellConfigService: ReactShellConfigService,
        @Optional() private readonly encryptionConfigService?: EncryptionConfigService,
        @Optional() @Inject(WRAPPER_VERSION) private readonly wrapperVersion?: WrapperVersion | null,
        @Optional() private readonly floodgateService?: FloodgateService
    ) {
    }

    public bootstrapOfficeStart() {
        return bootstrapOfficeStart(
            this.aadAppId,
            this.accessTokenService,
            this.capabilitiesService,
            this.contextService,
            this.errorDialogService,
            this.fluidHostContext,
            this.fluidInstrumentationService,
            this.instrumentationService,
            this.officeHomeApiConfigService,
            this.officeRouteService,
            this.clientStartupConfigService,
            this.performanceService,
            this.ariaEventFactoryService,
            this.serviceWorkerStateService,
            this.scheduler,
            this.dataSecurityService,
            this.deviceDetector,
            this.ngZone,
            this.wacContentService,
            this.workloadQueryParam,
            this.uploadLocalFileService,
            this.userContextService,
            this.userProfileService,
            this.reactShellConfigService,
            this.encryptionConfigService,
            this.wrapperVersion,
            this.floodgateService
        );
    }
}
